import { forwardRef, useEffect } from 'react';
import { StyledToast } from './styled';
import { useToast } from '../../../hooks';
import { useToastContext } from '../../../contexts/toast';

const Toast = forwardRef((props, ref) => {
  const { duration } = props;

  const toastProps = useToast(props);
  const { closeToast } = useToastContext();

  useEffect(() => {
    setTimeout(() => closeToast(props.id), duration || 5000);
  });

  return <StyledToast ref={ref} {...toastProps} />;
});

export default Toast;
